import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import {
  ErrorResponse,
  MessageErrorResponse
} from "../../../../../requests/@types";
import api from "../../../../../services/api";
import { removeSurroundingQuotes } from "../../../../network/util";
import { RLCSMergedReportResponse } from "../../../@types/rldynamicanalysis/rlcs-responses";
import { sampleReportKeys } from "../../../queryKeys";

const { cloud_enabled: cloudEnabled } = window.tcbase.consts;

export const defaultMergedURLReportConfig = (url: string) => ({
  queryKey: sampleReportKeys.mergedURLReportKey(url),
  queryFn: () => api.rlSandboxMergedReportUrl(removeSurroundingQuotes(url)),
  select: ({ data }: AxiosResponse<RLCSMergedReportResponse>) => data,
  retry: false,
  enabled: Boolean(url && cloudEnabled)
});
export const useGetMergedRlcsURLReport = (
  url: string,
  options?: UseQueryOptions
) => {
  const {
    data,
    isSuccess,
    isLoading: isLoadingMerged,
    isError,
    refetch: refetchMergedURLReport,
    error
  } = useQuery({
    ...defaultMergedURLReportConfig(url),
    ...options
  });
  return {
    data: data as RLCSMergedReportResponse,
    isLoadingMerged,
    isSuccess,
    isError,
    refetchMergedURLReport,
    error: error as ErrorResponse<MessageErrorResponse> | null
  };
};
